export default __webpack_public_path__ + "static/media/lisieux05.8a51b479.jpg";